import VideoClipIcon from '@atlaskit/icon-lab/core/video-clip';
import * as React from 'react';

export function SvgClip() {
  return <VideoClipIcon label="" testId="ads-refreshed-icon" />;
}
